export default __webpack_public_path__ + "static/media/thumbnail.fea45d80.png";